module.exports = __webpack_public_path__ + "img/msj.9e21edca.png";